import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {fetchTagById} from "../../store/tag-slice";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import {getDetailData, getProductWithTagColumns, getProductWithTagData} from "../../models/tagModel";
import {getValidatedLimit} from "../../components/Utility";
import Table from "../../components/common/table/Table";
import {fetchProductList} from "../../store/list-slice";

const TagDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.tag);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.tag);

    const list = useSelector(state => state.list);
    const {
        items: productList,
    } = list.product;

    const userRole = useSelector((state) => state.auth.selectedRole);


    useEffect(() => {
        dispatch(fetchTagById({...userRole, id: params.tagId}));
        dispatch(fetchProductList({...userRole, tagId: params.tagId, allProducts: true}));
    }, [dispatch, params.tagId, userRole]);

    const item = items.find(item => item.id === params.tagId);
    const products = item?.products || [];

    const tableColumns = getProductWithTagColumns();
    const tableData = getProductWithTagData({productList, products});
    const detailData = getDetailData({item})

    return (
        <>
            <SubHeader title="Tag Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" &&
                    <>
                        <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>

                        <h6 className="mt-4">Assigned Products</h6>
                        <Table className="mobile-responsive" columns={tableColumns} data={tableData}/>
                    </>
                }
            </div>
        </>
    )
}
export default TagDetail
